import { render, staticRenderFns } from "./Licenze.vue?vue&type=template&id=4d2eb2c8&"
import script from "./Licenze.vue?vue&type=script&lang=js&"
export * from "./Licenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports